import {
  api,
  // apiNotSensedia 
} from "../middlewares";

async function getTermos() {
  let resultGetTermos = "";
  try {
    resultGetTermos = await api.get("Termos/GetTermos");
    // resultGetTermos = await apiNotSensedia.get("termos/gettermos");

    return resultGetTermos.data;
  } catch (error) {
    return error.request;
  }
}

async function handleAcceptAccessTerm(TermoId) {
  try {
    await api.post(
      "Termos/AceiteTermos",
      {},
      {
        params: {
          TermoId: TermoId,
        },
      }
    );
  } catch (error) {
    return [];
  }
}

async function getPoliticaDePrivacidade() {
  try {
    const result = await api.get("Termos/GetPoliticaDePrivacidade");

    return result?.data[0]?.UriPdf;
  } catch (error) {
    return [];
  }
}

export { getTermos, handleAcceptAccessTerm, getPoliticaDePrivacidade };
